//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/ns-icon";
import { getProduct, getTranslations } from "../services/product.js";
import { isNullOrEmpty } from "@nuskin/ns-common-lib";

export default {
  name: "ProductCard",
  components: {
    NsIcon
  },
  props: {
    /**
     * id -> can be the product UID, SKU, Global ID, etc. If present, will pull new data in for props via product-lib via getProductById
     */
    id: {
      type: String,
      default: ""
    },
    /**
     * slug -> If present, will pull new data in for props via product-lib via getProductBySlug
     */
    slug: {
      type: String,
      default: ""
    },
    /**
     * env -> environment for product api call
     */
    env: {
      type: String,
      default: ""
    },
    /**
     * market -> market for product api call
     */
    market: {
      type: String,
      default: ""
    },
    /**
     * language -> language for product api call
     */
    language: {
      type: String,
      default: ""
    },
    /**
     * image-url -> the source of the main image for the product card
     */
    imageUrl: {
      type: String,
      default: "https://via.placeholder.com/150"
    },
    /**
     * image-alt -> the alternative information for the main image for the product card if the imageUrl doesn't work
     */
    imageAlt: {
      type: String,
      default: "product card - click here to see product detail page"
    },
    /**
     * title -> the title of the product
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * price-object -> the price object from our product api, can contain the following:
     * {
          "currencyCode": "USD",
          "retail": 15,
          "wholesale": 11,
          "retailSales": null,
          "wholesaleSales": null,
          "retailSubscription": 14,
          "wholesaleSubscription": 10
        }
     */
    priceObject: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * points-object -> the points object from our product api, can contain the following:
     * {
          "subscription": {
            "cv": null,
            "pv": null,
            "sb": null
          },
          "wholesale": {
            "cv": 11,
            "pv": 11,
            "sb": null
          }
        }
     */
    pointsObject: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * translations-object -> ADD TO CART, ITEM, etc translated into desired language
     */
    translationsObject: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * show-add-to-cart -> determines if add to cart button should be shown
     */
    showAddToCart: {
      type: Boolean,
      default: false
    },
    /**
     * is-wholesale -> determines if the product is wholesale or not, otherwise is retail
     */
    isWholesale: {
      type: Boolean,
      default: false
    },
    /**
     * is-subscription -> determines if the product is subscribable or not
     */
    isSubscription: {
      type: Boolean,
      default: false
    },
    /**
     * is-sales-event -> determines if a sales event is going on or not
     */
    isSalesEvent: {
      type: Boolean,
      default: false
    },
    /**
     * okta-token -> used to determine user type (not logged in meaning they have no account, or logged in and showing retail, brand affiliate or member/preferred)
     */
    oktaToken: {
      type: String,
      default: ""
    },
    /**
     * quantity -> how many of the products should be used to get pricing (defaults to one)
     */
    quantity: {
      type: String,
      default: "1"
    },
    /**
     * sku-if-not-first-variant -> for getPricing(), if the sku isn't the first variant sku, use this sku to assign sku and id for getting pricing
     */
    // skuIfNotFirstVariant: {
    //   type: String,
    //   default: ""
    // },
    /**
     * selected-skus -> for getPricing(), will use the SKUs in that array for pricing for bundles (in case you have optional SKUs you need to include in pricing or want a specific variant of one of the mandatory products
     */
    selectedSkus: {
      type: Array,
      default() {
        return [];
      }
    },
    /** using-props ->
     *  when your sending props in, instead of using async call in this component.
     *  (suggested for use with multiple products being composed for a carousel/list for example, for performance reasons) */
    usingProps: {
      type: Boolean,
      default: true
    },
    /** product -> product as prop instead of async call */
    product: {
      type: Object,
      default: () => ({})
    },
    /** is child of ProductListComponent  */
    productListChild: {
      type: Boolean,
      default: false
    },
    /** noRedirectOnClick prop allows override of default anchor to PDP behavior
     *  see handleCardClick() on how to create new functionality
     */
    noRedirectOnClick: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      productData: null,
      translationData: null,
      isError: false,
      anchorSlug: "",
      anchorHref: ""
    };
  },
  computed: {
    classes() {
      const classes = this.productListChild
        ? [this.$style.cardProductList]
        : [this.$style.card];
      return classes;
    },
    isVariants() {
      const variants =
        ((this.productData || {}).data || {}).variants ||
        (this.product || {}).variants;
      return !!(variants ? variants.length : null);
    },
    variants() {
      if (this.isVariants) {
        return (
          ((this.productData || {}).data || {}).variants ||
          (this.product || {}).variants
        );
      }
      return null;
    },
    selectedVariant() {
      if (this.isVariants) {
        // const variant = this.variants.find(
        //   ({ sku, globalId, slug, id }) =>
        //     sku === this.skuIfNotFirstVariant ||
        //     globalId === this.id ||
        //     sku === this.id ||
        //     slug === this.slug ||
        //     id === this.id
        // );
        const firstVariant = this.variants[0];
        // if (!isNullOrEmpty(variant)) {
        //   return variant;
        // }
        return firstVariant;
      }
      return null;
    },
    isBundle() {
      const bundle =
        ((this.productData || {}).data || {}).bundle ||
        (this.product || {}).bundle;
      return !isNullOrEmpty(bundle);
    },
    selectedBundle() {
      if (this.isBundle) {
        return (
          ((this.productData || {}).data || {}).bundle ||
          (this.product || {}).bundle
        );
      }
      return null;
    },
    // by "smart", we mean that the inital props can potentially be
    // updated by an api call should the "useProps" prop be false
    smartSku() {
      if (this.isVariants) {
        return this.selectedVariant.sku;
      }
      if (this.isBundle) {
        if (this.skuIfNotFirstVariant) {
          return this.selectedBundle.kitProducts.find(
            ({ product }) =>
              product.variants[0].sku === this.skuIfNotFirstVariant
          );
        }
        return this.selectedBundle.kitProducts[0].product.variants[0].sku;
      }
      return null;
    },
    smartTitle() {
      if (this.isBundle) {
        return ((this.productData || {}).data || {}).title || this.title;
      }
      if (this.isVariants) {
        return this.selectedVariant.title || this.title;
      }
      return this.title;
    },
    smartImageUrl() {
      if (this.isBundle) {
        return (
          ((((this.productData || {}).data || {}).productImages || [])[0] || {})
            .url || this.imageUrl
        );
      }
      if (this.isVariants) {
        return (
          ((this.selectedVariant.productImages || [])[0] || {}).url ||
          ((((this.productData || {}).data || {}).productImages || [])[0] || {})
            .url ||
          this.imageUrl
        );
      }
      return this.imageUrl;
    },
    smartImageAlt() {
      if (this.isBundle) {
        return (
          ((((this.productData || {}).data || {}).productImages || [])[0] || {})
            .alt || this.imageAlt
        );
      }
      if (this.isVariants) {
        return (
          ((this.selectedVariant.productImages || [])[0] || {}).alt ||
          ((((this.productData || {}).data || {}).productImages || [])[0] || {})
            .alt ||
          this.imageAlt
        );
      }
      return this.imageAlt;
    },
    smartPrice() {
      // passed in props via priceObject:
      let currencyCode = (this.priceObject || {}).currencyCode || null;
      let retail = (this.priceObject || {}).retail || null;
      let retailSales = (this.priceObject || {}).retailSales || null;
      let retailSubscription =
        (this.priceObject || {}).retailSubscription || null;
      let wholesale = (this.priceObject || {}).wholesale || null;
      let wholesaleSales = (this.priceObject || {}).wholesaleSales || null;
      let wholesaleSubscription =
        (this.priceObject || {}).wholesaleSubscription || null;
      // productData - update props if variant or bundle exist from productLib.getProduct() and productLib.getPricing()
      if (this.isVariants) {
        currencyCode = (this.selectedVariant.price || {}).currencyCode || null;
        retail =
          (this.selectedVariant.totalPrice || {}).retail ||
          (this.selectedVariant.price || {}).retail ||
          null;
        retailSales =
          (this.selectedVariant.totalPrice || {}).retailSales ||
          (this.selectedVariant.price || {}).retailSales ||
          null;
        retailSubscription =
          (this.selectedVariant.totalPrice || {}).retailSubscription ||
          (this.selectedVariant.price || {}).retailSubscription ||
          null;
        wholesale =
          (this.selectedVariant.totalPrice || {}).wholesale ||
          (this.selectedVariant.price || {}).wholesale ||
          null;
        wholesaleSales =
          (this.selectedVariant.totalPrice || {}).wholesaleSales ||
          (this.selectedVariant.price || {}).wholesaleSales ||
          null;
        wholesaleSubscription =
          (this.selectedVariant.totalPrice || {}).wholesaleSubscription ||
          (this.selectedVariant.price || {}).wholesaleSubscription ||
          null;
      }
      if (this.isBundle) {
        currencyCode =
          ((this.selectedBundle || {}).price || {}).currencyCode || null;
        retail = ((this.selectedBundle || {}).price || {}).retail || null;
        retailSales =
          ((this.selectedBundle || {}).price || {}).retailSales || null;
        retailSubscription =
          ((this.selectedBundle || {}).price || {}).retailSubscription || null;
        wholesale = ((this.selectedBundle || {}).price || {}).wholesale || null;
        wholesaleSales =
          ((this.selectedBundle || {}).price || {}).wholesaleSales || null;
        wholesaleSubscription =
          ((this.selectedBundle || {}).price || {}).wholesaleSubscription ||
          null;
      }
      const price =
        this.isWholesale && this.isSubscription
          ? wholesaleSubscription
          : this.isWholesale && this.isSalesEvent
          ? wholesaleSales
          : this.isWholesale
          ? wholesale
          : this.isSubscription
          ? retailSubscription
          : this.isSalesEvent
          ? retailSales
          : retail;
      return this.formatCurrency(
        price,
        currencyCode,
        `${this.language ? this.language : "en"}-${
          this.market ? this.market.toUpperCase() : "US"
        }`
      );
    }
    // here if we decide to show psv, might need a few styling tweaks if used
    // smartPsv() {
    //   if (this.isVariants) {
    //     if (this.isWholesale) {
    //       return (
    //         (((this.selectedVariant || {}).totalPoints || {}).wholesale || {})
    //           .pv ||
    //         (((this.selectedVariant || {}).points || {}).wholesale || {}).pv ||
    //         ((this.pointsObject || {}).wholesale || {}).pv
    //       );
    //     }
    //     if (this.isSubscription) {
    //       return (
    //         (
    //           ((this.selectedVariant || {}).totalPoints || {}).subscription ||
    //           {}
    //         ).pv ||
    //         (((this.selectedVariant || {}).points || {}).subscription || {})
    //           .pv ||
    //         ((this.pointsObject || {}).subscription || {}).pv
    //       );
    //     }
    //   } else if (this.isBundle) {
    //     if (this.isWholesale) {
    //       return (
    //         (((this.selectedBundle || {}).totalPoints || {}).wholesale || {})
    //           .pv ||
    //         (((this.selectedBundle || {}).points || {}).wholesale || {}).pv ||
    //         ((this.pointsObject || {}).wholesale || {}).pv
    //       );
    //     }
    //     if (this.isSubscription) {
    //       return (
    //         (((this.selectedBundle || {}).totalPoints || {}).subscription || {})
    //           .pv ||
    //         (((this.selectedBundle || {}).points || {}).subscription || {})
    //           .pv ||
    //         ((this.pointsObject || {}).subscription || {}).pv
    //       );
    //     }
    //   }
    //   if (this.isWholesale) {
    //     return ((this.pointsObject || {}).wholesale || {}).pv;
    //   } else if (this.isSubscription) {
    //     return ((this.pointsObject || {}).subscription || {}).pv;
    //   }
    //   return null;
    // }
  },
  watch: {
    id: {
      handler() {
        this.getProductData();
        this.getProductTranslations();
      },
      immediate: true
    }
  },
  methods: {
    async getProductData() {
      // this should only run if id and/or slug are non null
      if ((this.slug || this.id) && !this.usingProps) {
        const response = await getProduct(
          this.slug || null,
          this.id,
          this.env,
          this.market,
          this.lanuage,
          this.quantity,
          this.skuIfNotFirstVariant,
          this.oktaToken,
          this.selectedSkus
        );
        this.productData = response;
        this.isError =
          response && response.data && response.data.error
            ? response.data.error
            : false;
        if (this.isError) {
          this.$emit("error", { isCardLoaded: false });
          console.warn(
            "There has been an error thrown while querying for a singular product by ID:",
            this.isError
          );
        } else {
          if (response && response.data && response.data.slug) {
            this.anchorSlug = response.data.slug;
          }
          if (this.anchorSlug && this.market && this.env) {
            this.anchorHref =
              window.location.origin +
              `/catalog/${this.market}/${this.language}/product/${this.anchorSlug}`;
          } else {
            this.anchorSlug = window.location.href;
          }
          this.$emit("success", { isCardLoaded: true });
        }
      }
      this.anchorHref =
        window.location.origin +
        `/catalog/${this.market}/${this.language}/product/${this?.product?.slug}`;
    },
    async getProductTranslations() {
      if (this.market && this.env && !this.usingProps) {
        const response = await getTranslations(
          this.market,
          this.language,
          this.env
        );
        this.translationData = response;
      } else {
        this.translationData = this.translationsObject;
      }
    },
    formatCurrency(price, currencyCode, currencyLocale) {
      return new Intl.NumberFormat(currencyLocale || "en-US", {
        style: "currency",
        currency: currencyCode || "USD",
        currencyDisplay: "narrowSymbol"
      }).format(typeof price === "object" ? 0 : price || 0);
    },
    handleAddToCart() {
      this.$emit("add-to-cart");
      // listen to event on ProductCard like so:
      // @add-to-cart="handleAddToCart" where handleAddToCart will be your custom functionality
      // :show-add-to-cart="true" prop must be added to see btn in card
      // see ShowProductCardEvents.vue for example
    },
    handleAddSubscription() {
      this.$emit("add-subscription");
      // listen to event on ProductCard like so:
      // @add-subscription="handleAddSubscription" where handleAddSubscription will be your custom functionality
      // :is-subscription="true" prop must be added to see btn in card
      // see ShowProductCardEvents.vue for example
    },
    handleCardClick() {
      this.$emit("card-clicked");
      // listen to event on ProductCard like so:
      // @card-clicked="handleCardClick" where handleCardClick will be your custom functionality
      // if overriding default card click behavior to navigate user to PDP, also add prop i.e. :no-redirect-on-click="true"
      // see ShowProductCardEvents.vue for example
    }
  }
};
